@if (isLoading) {
<p>Loading doc cases...</p>
} @else if (docCases.length === 0) {
<p>No doc cases found.</p>
} @else {

<div class="corp-table">

    <div class="bg-white rounded-3 overflow-hidden">
        <div class="row m-0">
            <div class="col-md-4 p-0 border-end case-a">
                <div class="px-3 border-bottom case-title">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="fs-4">Case <span style="color: #fff; font-size: 26px">A</span></div>
                        <div class="casePrice">
                            @if (totalFee !== null) {
                                ${{ totalFee }} <small>+%5</small>
                            } @else {
                                $50 <small>+%5</small>
                            }
                        </div>
                        <div style="color: red">
                            @if (totalTime !== null) {
                                {{ totalTime === 1 ? '24h.' : totalTime + ' B.D.' }}
                            } @else {
                                24h.
                            }
                            <span style=" font-size: 12px; color: #000;">Service</span>
                        </div>
                    </div>
                </div>
                <div class="p-1 border-bottom case-a-desc text-center" style="min-height: 120px; line-height: 1;">
                    <div class="lookAsLabel" (click)="showCaseContent($event.currentTarget)">
                        Accepted as a digital document.
                        <i class="fa-solid fa-circle-down"></i>
                    </div>
                    <div class="small text-muted mt-1">Notary public is not required.</div>
                </div>
                <div class="p-3 case-content-select">
                    @for (doc of corpDocsAcceptDigital; track doc.id) {
                    <div class="form-check d-flex align-items-center">
                        <div class="d-flex align-items-center checkboxContainer">
                            <input class="form-check-input me-2" type="checkbox" name="{{doc.id}}" id="{{doc.id}}"
                                value="{{doc.name}}" [checked]="orderSelection.getQuantity(doc.id) > 0"
                                (change)="onCheckboxChange(doc, $event)" [disabled]="orderSelection.showOrderProcess()">
                            <label class="form-check-label" for="{{doc.id}}">
                                {{doc.name}}
                                @if(doc.note){
                                <br>
                                <span class="small">{{doc.note}}</span>
                                }
                            </label>
                        </div>
                        @if (orderSelection.getQuantity(doc.id) > 0) {
                        <div class="plusMinsContainer" style="display: flex;">
                            <button class="mins-btn" (click)="decrement(doc)" [disabled]="orderSelection.showOrderProcess()">
                                <span class="material-symbols-outlined">
                                    remove
                                </span>
                            </button>
                            <input type="text" class="form-control documentValue text-primary"
                                [value]="orderSelection.getQuantity(doc.id)" readonly>
                            <button class="plus-btn" (click)="increment(doc)" [disabled]="orderSelection.showOrderProcess()">
                                <span class="material-symbols-outlined">
                                    add
                                </span>
                            </button>
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>

            <div class="col-md-4 p-0 border-end case-b">
                <div class="px-3 border-bottom case-title">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="fs-4">Case <span style="color: #fff; font-size: 26px">B</span></div>
                        <div class="casePrice">
                            @if (totalFee !== null) {
                                ${{ totalFee }} <small>+%5</small>
                            } @else {
                                $50 <small>+%5</small>
                            }
                        </div>
                        <div style="color: red">
                            @if (totalTime !== null) {
                                {{ totalTime === 1 ? '24h.' : totalTime + ' B.D.' }}
                            } @else {
                                24h.
                            }
                            <span style=" font-size: 12px; color: #000;">Service</span>
                        </div>
                    </div>
                </div>
                <div class="p-1 border-bottom case-b-desc text-center" style="min-height: 120px; line-height: 1;">
                    <div class="lookAsLabel" (click)="showCaseContent($event.currentTarget)">
                        Accepted as a digital document.
                        <i class="fa-solid fa-circle-down"></i>
                    </div>
                    <div class="small text-muted mt-1">
                        physical&nbsp;Notary public is required.<br>
                        Digital signature is not accepted.<br>
                        Online notary is not accepted.
                    </div>
                </div>
                <div class="p-3 case-content-select">
                    @for (doc of corpDocsAcceptPhysicalNotary; track $index) {
                    <div class="form-check d-flex align-items-center">
                        <div class="d-flex align-items-center checkboxContainer">
                            <input class="form-check-input me-2" type="checkbox" name="{{doc.id}}" id="{{doc.id}}"
                                value="{{doc.name}}" [checked]="orderSelection.getQuantity(doc.id) > 0"
                                (change)="onCheckboxChange(doc, $event)" [disabled]="orderSelection.showOrderProcess()">
                            <label class="form-check-label" for="{{doc.id}}">
                                {{doc.name}}
                                @if(doc.note){
                                <br>
                                <span class="small">{{doc.note}}</span>
                                }
                            </label>
                        </div>
                        @if (orderSelection.getQuantity(doc.id) > 0) {
                        <div class="plusMinsContainer" style="display: flex;">
                            <button class="mins-btn" (click)="decrement(doc)" [disabled]="orderSelection.showOrderProcess()">
                                <span class="material-symbols-outlined">
                                    remove
                                </span>
                            </button>
                            <input type="text" class="form-control documentValue text-primary"
                                [value]="orderSelection.getQuantity(doc.id)" readonly>
                            <button class="plus-btn" (click)="increment(doc)" [disabled]="orderSelection.showOrderProcess()">
                                <span class="material-symbols-outlined">
                                    add
                                </span>
                            </button>
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>

            <div class="col-md-4 p-0 case-c">
                <div class="px-3 border-bottom case-title">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="fs-4">Case <span style="color: #fff; font-size: 26px">C</span></div>
                        <div class="casePrice">
                            @if (totalFee !== null) {
                                ${{ totalFee }} <small>+%5</small>
                            } @else {
                                $50 <small>+%5</small>
                            }
                        </div>
                        <div style="color: red">
                            @if (totalTime !== null) {
                                {{ totalTime === 1 ? '24h.' : totalTime + ' B.D.' }}
                            } @else {
                                24h.
                            }
                            <span style=" font-size: 12px; color: #000;">Service</span>
                        </div>
                    </div>
                </div>
                <div class="p-1 border-bottom case-c-desc text-center" style="min-height: 120px; line-height: 1;">
                    <div class="lookAsLabel" (click)="showCaseContent($event.currentTarget)">
                        <div>
                            <span style="color: yellow;">Not</span> accepted as a digital document.
                        </div>
                        <i class="fa-solid fa-circle-down"></i>
                    </div>
                    <div class="small text-muted mt-1">
                        The documents must be signed with wet ink.<br>
                        Also must be notarized in person not digitally.<br>
                        Documents must be mailed or FedExed.
                    </div>
                </div>
                <div class="p-3 case-content-select">
                    @for (doc of corpDocsNotAccept; track $index) {
                    <div class="form-check d-flex align-items-center">
                        <div class="d-flex align-items-center checkboxContainer">
                            <input class="form-check-input me-2" type="checkbox" name="{{doc.id}}" id="{{doc.id}}"
                                value="{{doc.name}}" [checked]="orderSelection.getQuantity(doc.id) > 0"
                                (change)="onCheckboxChange(doc, $event)" [disabled]="orderSelection.showOrderProcess()">
                            <label class="form-check-label" for="{{doc.id}}">
                                {{doc.name}}
                                @if(doc.note){
                                <br>
                                <span class="small">{{doc.note}}</span>
                                }
                            </label>
                        </div>
                        @if (orderSelection.getQuantity(doc.id) > 0) {
                        <div class="plusMinsContainer" style="display: flex;">
                            <button class="mins-btn" (click)="decrement(doc)" [disabled]="orderSelection.showOrderProcess()">
                                <span class="material-symbols-outlined">
                                    remove
                                </span>
                            </button>
                            <input type="text" class="form-control documentValue text-primary"
                                [value]="orderSelection.getQuantity(doc.id)" readonly>
                            <button class="plus-btn" (click)="increment(doc)" [disabled]="orderSelection.showOrderProcess()">
                                <span class="material-symbols-outlined">
                                    add
                                </span>
                            </button>
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>

}